import { IAssignLocalityMaintenanceTemplate } from 'src/generated-types/localityMaintenanceTemplate'
import { IMaintenanceTemplate } from 'src/generated-types/maintenanceTemplate'
import { queryClient } from '../query-client'
import { useDelete, useGet, usePost, usePut } from './reactQuery'

const baseUrl = (customerId: EntityId) => `customers/${customerId}/maintenance-templates`

export const endpoints = {
  getMaintenanceTemplates(customerId: EntityId) {
    return `${baseUrl(customerId)}`
  },
  getEquipmentMaintenanceTemplates(customerId: EntityId) {
    return `${baseUrl(customerId)}/get-equipment-maintenance-templates`
  },
  getLocalityMaintenanceTemplates(customerId: EntityId) {
    return `${baseUrl(customerId)}/get-locality-maintenance-templates`
  },
  getAssignLocalityMaintenanceTemplates(customerId: EntityId) {
    return `${baseUrl(customerId)}/assign-locality`
  },
  getMaintenanceTemplate(customerId: EntityId, id: EntityId) {
    return `${baseUrl(customerId)}/${id}`
  },
  createMaintenanceTemplate(customerId: EntityId) {
    return `${baseUrl(customerId)}`
  },
  updateMaintenanceTemplate(customerId: EntityId, id: EntityId) {
    return `${baseUrl(customerId)}/${id}`
  },
  deleteMaintenanceTemplate(customerId: EntityId) {
    return `${baseUrl(customerId)}`
  },
}

export const invalidateMaintenanceTemplateCache = {
  getMaintenanceTemplates(customerId: EntityId) {
    queryClient.invalidateQueries(endpoints.getMaintenanceTemplates(customerId))
  },
  getMaintenanceTemplate(customerId: EntityId, id: EntityId) {
    queryClient.invalidateQueries(endpoints.getMaintenanceTemplate(customerId, id))
  },
  getEquipmentMaintenanceTemplates(customerId: EntityId) {
    queryClient.invalidateQueries(endpoints.getEquipmentMaintenanceTemplates(customerId))
  },
  getLocalityMaintenanceTemplates(customerId: EntityId) {
    queryClient.invalidateQueries(endpoints.getLocalityMaintenanceTemplates(customerId))
  },
}

export const useGetMaintenanceTemplates = (customerId: EntityId) =>
  useGet<IMaintenanceTemplate[]>(endpoints.getMaintenanceTemplates(customerId))

export const useGetEquipmentMaintenanceTemplates = (customerId: EntityId) =>
  useGet<IMaintenanceTemplate[]>(endpoints.getEquipmentMaintenanceTemplates(customerId))

export const useGetLocalityMaintenanceTemplates = (customerId: EntityId) =>
  useGet<IMaintenanceTemplate[]>(endpoints.getLocalityMaintenanceTemplates(customerId))

export const useGetMaintenanceTemplate = (customerId: EntityId, id: EntityId) =>
  useGet<IMaintenanceTemplate>(endpoints.getMaintenanceTemplate(customerId, id))

export const useAddMaintenanceTemplate = (customerId: EntityId) =>
  usePost<IMaintenanceTemplate, IMaintenanceTemplate>(endpoints.createMaintenanceTemplate(customerId))

export const useAssignMaintenanceTemplate = (customerId: EntityId) =>
  usePost<IAssignLocalityMaintenanceTemplate, IAssignLocalityMaintenanceTemplate>(endpoints.getAssignLocalityMaintenanceTemplates(customerId))

export const useUpdateMaintenanceTemplate = (customerId: EntityId, id: EntityId) =>
  usePut<IMaintenanceTemplate, IMaintenanceTemplate>(endpoints.updateMaintenanceTemplate(customerId, id))

export const useDeleteMaintenanceTemplate = (customerId: EntityId) =>
  useDelete<IMaintenanceTemplate>(endpoints.deleteMaintenanceTemplate(customerId))
